import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { globals } from '../globals';
import { PaginatedModel } from "../dominio/paginated-model";
import { ProdutoLoteModel } from "../dominio/produto-lote-model";
import { QueryFilterService } from "../core/services/query-filter-service";
import { Observable } from "rxjs";
import { IGridifyQuery } from "gridify-client";

export class DetalharProdutoLoteResponse {
  result: ProdutoLoteModel;
}

export class ListarProdutoLoteResponse {
  results: ProdutoLoteModel[];
  pagination: PaginatedModel;
}

export class AtualizarProdutoLoteRequest {
  lote: string;
}

@Injectable({
  providedIn: "root",
})
export class ProdutoLoteService {
  constructor(private http: HttpClient, private queryFilterService: QueryFilterService) {}

  listar(idProduto: number, queryFilter: IGridifyQuery | null = null): Observable<ListarProdutoLoteResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<ListarProdutoLoteResponse>(`${globals.apiUrl}/api/v2/core/produtos/${idProduto}/lotes`, {
      params,
    });
  }

  detalhar(idProduto: number, id: number): Observable<DetalharProdutoLoteResponse> {
    return this.http.get<DetalharProdutoLoteResponse>(
      `${globals.apiUrl}/api/v2/core/produtos/${idProduto}/lotes/${id}`
    );
  }

  cadastrar(idProduto: number, data: FormData): Observable<DetalharProdutoLoteResponse> {
    return this.http.post<DetalharProdutoLoteResponse>(
      `${globals.apiUrl}/api/v2/core/produtos/${idProduto}/lotes`,
      data
    );
  }

  atualizar(idProduto: number, id: number, data: AtualizarProdutoLoteRequest): Observable<DetalharProdutoLoteResponse> {
    return this.http.put<DetalharProdutoLoteResponse>(
      `${globals.apiUrl}/api/v2/core/produtos/${idProduto}/lotes/${id}`,
      data
    );
  }

  excluir(idProduto: number, id: number): Observable<void> {
    return this.http.delete<void>(`${globals.apiUrl}/api/v2/core/produtos/${idProduto}/lotes/${id}`);
  }

  importar(dados: FormData) {
    return this.http.post(globals.apiUrl + "/api/v2/core/produtos/importar/lotes", dados);
  }
}
